module.exports = __webpack_public_path__ + "static/media/title.8249b406.svg";